import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { chain, DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";

type HandlerType = Handler;

export const DeleteSessionCustom: HandlerType = () => {
    localStorage.removeItem("checkoutAccessorial");
    localStorage.removeItem("checkoutAccessorialCompleted");
    localStorage.removeItem("orderNotes");
};

addToChainAfter(chain, DeleteSession, DeleteSessionCustom);
